import axios from 'axios';

export const QUICK_CASHFLOW_ALLOWED_MODELS = [
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-4.1',
  'gpt-4.1-mini',
  'gpt-5.1',
  'gpt-5-mini',
  'gpt-5.4',
  'gpt-5.4-mini',
  'gpt-5.4-nano',
  'gpt-5.5',
];

export const DEFAULT_QUICK_CASHFLOW_EXTRACTION_PROMPT = `You extract financial inputs for a Quick Cash Flow model.

For trial balance, balance sheet, and P&L uploads:
- gpm: gross profit margin as a percentage (0-100), averaged over recent months when possible
- opex: average monthly regular operating expenses in dollars (positive number), excluding user acquisition / marketing / UA / paid media / ad spend. If P&L shows marketing/UA/ad spend separately, omit those lines from the opex sum (or subtract them from total OpEx). If marketing is embedded in SG&A and not separable, estimate and document in reason; prefer sheets that break out marketing separately. Watch for subtotals and totals: many P&Ls show detail OpEx lines plus "Subtotal" / "Total OpEx" / "Total operating expenses" / "Total SG&A" rows — never add subtotals or totals together with the detail lines they summarize (that double-counts). Prefer a single labeled total OpEx line per month when clearly present; otherwise sum only leaf/detail lines and skip subtotal/total rows. opex.reason must list periods used, lines included, what marketing/UA was excluded (with amounts when visible), which approach was used (total row vs detail sum), and confirm subtotals were not double-counted.
- beginCash: current cash and cash equivalents in dollars (positive number)
Set accounting.applied true when you extracted any accounting field from uploaded files.

For cohort / ROAS / retention revenue uploads:
- roas.value: cumulative ROAS vector as percentages by month (M0, M1, ...). Each value is cumulative percent of marketing spend recovered as revenue by end of that month. Values should generally rise monotonically.
Set cohort.applied true when you extracted a ROAS vector.

Always explain methodology in explanation and in each field's reason. If a value cannot be determined, set value to null and explain in reason. Never invent numbers.`;

export const getLatestQuickCashflowAiConfig = async () => {
  const response = await axios.get('admin/quick-cashflow-ai-config/latest');
  return response.data;
};

export const listQuickCashflowAiConfigVersions = async () => {
  const response = await axios.get('admin/quick-cashflow-ai-config/versions');
  return response.data;
};

export const getQuickCashflowAiConfigVersion = async (version) => {
  const response = await axios.get(
    `admin/quick-cashflow-ai-config/versions/${version}`
  );
  return response.data;
};

export const createQuickCashflowAiConfigVersion = async (body) => {
  const response = await axios.post('admin/quick-cashflow-ai-config', body);
  return response.data;
};
